// ============== import plugin ============= //
import React,{useState, useRef, useEffect} from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import axios from 'axios'
import { useParams, useNavigate, Link } from "react-router-dom";
// ============= import module ============= //
import SAISVG from '../../../../../../../_template/helpers/CommonFunction'
import { base64Encode } from '../../../../../../component/common/Helper';

// =========== import component =========== //

import ValidationMessage from '../../../../../../component/common/ValidationMessage';

const Step1 = (props) => {

    const { param_bot_id } = useParams();
    const api_base_url = process.env.REACT_APP_API_URL;
    const { formValidateError, formData, paramBotId } = props;
 
    let apiToken = '';
    const loginUserType = localStorage.getItem('type');
    if(loginUserType === 'A'){
        apiToken = localStorage.getItem('token')
    } else if(loginUserType === 'D'){
        apiToken = localStorage.getItem('developertoken')
    } else if(loginUserType === 'SA') {
        apiToken = localStorage.getItem('systemAdminToken')
    }
    const api_headers = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "x-access-token" : apiToken
        }
    };

    // ---------------- set language and channel -------------- //
    const [languageList, setLanguageList] = useState([]);
    const [channelList, setChannelList] = useState([]);
    const setLanguageAndChannel = async () => {
        await axios.post(`${api_base_url}admin/get-language-and-channel`,{sass_id: localStorage.getItem('sass_id')}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                var resChannelList = res.data.data.channel_list;
                var resLanguageList = res.data.data.language_list;
                const formattedChannel = resChannelList.map(channel => ({
                    value: channel.unique_id,
                    label: channel.channel_name
                }));
                const formattedLanguages = resLanguageList.map(language => ({
                    value: language.unique_id,
                    label: language.language_name
                }));
                setChannelList(formattedChannel)
                setLanguageList(formattedLanguages)
            } else if(res.data.status === 'error') {
                console.error(res.data.message);
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    useEffect(() => {
        setLanguageAndChannel();
    },[]);

    // ----------- bot avtar preview ------------- //
    const botavtarInputRef = useRef(null);
    const selectBotAvtarHandler = () => {
        if (botavtarInputRef.current) {
            botavtarInputRef.current.click();
        }
    }
    const [botAvtarPreview, setBotAvtarPreview] = useState(formData.bot_avtar != null ? formData.bot_avtar.obj_url : '');
    const botAvtarChangeHandler = (event) => {
        const botAvtarFile = event.target.files[0];
        if(botAvtarFile){
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.naturalWidth === 160 && img.naturalHeight === 160) {
                        setBotAvtarPreview(URL.createObjectURL(botAvtarFile));
                        props.onInputChange('step1', 'bot_avtar', {file : botAvtarFile, obj_url: URL.createObjectURL(botAvtarFile)});
                    } else {
                        toast.error(`Invalid image dimensions: ${img.naturalWidth}x${img.naturalHeight}. Please upload an image of size 160x160.`);
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(botAvtarFile);
        }
    }
    const botAvtarPreviewRemoveHandler = () => {
        setBotAvtarPreview('')
        props.onInputChange('step1', 'bot_avtar', null);
        
    }

    // ------------- brand icon preview ------------- //
    const brandIconInputRef = useRef(null);
    const [brandIconPreview, setBrandIconPreview] = useState(formData.brand_icon != null ? formData.brand_icon.obj_url : '');
    const selectBrandIconHandler = () => {
        if (brandIconInputRef.current) {
            brandIconInputRef.current.click();
        }
    }
    const brandIconChangeHandler = (event) => {
        const brandIconFile = event.target.files[0];
        if(brandIconFile){
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.naturalWidth === 200 && img.naturalHeight === 200) {
                        setBrandIconPreview(URL.createObjectURL(brandIconFile));
                        props.onInputChange('step1', 'brand_icon', {file : brandIconFile, obj_url: URL.createObjectURL(brandIconFile)});
                    } else {
                        toast.error(`Invalid image dimensions: ${img.naturalWidth}x${img.naturalHeight}. Please upload an image of size 200x200.`);
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(brandIconFile);
        }
    }

    const brandIconPreviewRemoveHandler = () => {
        setBrandIconPreview('')
        props.onInputChange('step1', 'brand_icon', null);
    }

    useEffect(() => {
        if(formData.step1.bot_avtar !== null){
            if(formData.step1.bot_avtar.full_path){
                setBotAvtarPreview(formData.step1.bot_avtar.full_path)
            }
            else{
                setBotAvtarPreview(formData.step1.bot_avtar.obj_url)
            }
        }
        if(formData.step1.brand_icon !== null){
            if(formData.step1.brand_icon.full_path){
                setBrandIconPreview(formData.step1.brand_icon.full_path)
            }
            else{
                setBrandIconPreview(formData.step1.brand_icon.obj_url)
            }
        }
    },[formData]);

    const onChangeFunc = (param) => {
        const { name, value } = param;
        setWidgetType(value)
        props.onInputChange('step1', name, value)
        if(value === 'default_widget'){
            const api_base_url = process.env.REACT_APP_API_URL;
            const bot_url = process.env.REACT_APP_BOT_URL;
            const sass_id = localStorage.getItem('sass_id');
            const widgetScript = `<script src="${api_base_url+''+bot_url}" bizcode="${base64Encode(sass_id)}.....></script>`
            props.onInputChange('step1', 'widget_url', widgetScript);
            // props.onInputChange('step1', 'hook_url', '');
        }
        else{
            // props.onInputChange('step1', 'widget_url', '');
        }
    }

    const [widgetType, setWidgetType] = useState('')
    const widgetTypeChangeHandler = (e) => {
        const { name, value } = e.target;
        onChangeFunc({
            name: name,
            value: value
        })
    }
    useEffect(() => {
        if(formData.step1.widget_type !== ''){
            onChangeFunc({
                name: 'widget_type',
                value: formData.step1.widget_type
            })
        }
    }, [formData.step1.widget_type])
    
    return (
        <>
            <div className="row">
                <div className="col-md-4">
                    <div className="mb-5">
                        <label className="form-label required">
                            Agent Name
                        </label>
                        <input
                            type="text"
                            className={`form-control form-control-solid ${formValidateError.bot_name && 'is-invalid'}`}
                            placeholder="Enter agent name"
                            onChange={(e) => props.onInputChange('step1', 'bot_name', e.target.value)}
                            value={formData.step1.bot_name || ''}
                            disabled={!!param_bot_id}
                            autoFocus
                        />
                        {formValidateError.step1?.bot_name &&
                            <ValidationMessage className='text-danger' message ={formValidateError.step1.bot_name}/>
                        }
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="mb-5">
                        <label className="form-label required">
                            Channel Name
                        </label>
                        <Select
                            className="react-select-styled react-select-solid"
                            classNamePrefix="react-select"
                            options={channelList}
                            placeholder="Select an option"
                            value= {formData.step1.channel_name || null}
                            onChange={(e) => props.onInputChange('step1', 'channel_name', e)}
                        />
                        {formValidateError.step1?.channel_name && 
                            <ValidationMessage 
                                className='text-danger' 
                                message = {formValidateError.step1.channel_name}
                            />
                        }
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="mb-5">
                        <label className="form-label required">
                            Language
                        </label>
                        <Select 
                            className='react-select-styled react-select-solid' 
                            classNamePrefix='react-select' 
                            options={languageList} 
                            placeholder='Select an option'
                            onChange={(e) => props.onInputChange('step1', 'language', e)}
                            value= {formData.step1.language || null}
                        />
                        {formValidateError.step1?.language && 
                            <ValidationMessage className='text-danger' message ={formValidateError.step1.language}/>
                        }
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-5">
                        <label className="form-label">
                            Agent Description
                        </label>
                        <textarea 
                            className="form-control form-control-solid" 
                            rows="5"
                            onChange={(e) => props.onInputChange('step1', 'bot_description', e.target.value)}
                            value={formData.step1.bot_description || ''}
                        ></textarea>
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className="form-label">
                        &nbsp;
                    </label>
                    <div className="card-body border border-dashed border-gray-300 d-flex text-center flex-column bg-light p-5 align-items-center position-relative">
                        {!botAvtarPreview ?
                            <a
                                className="text-gray-800 d-flex flex-column cursor-pointer" 
                                onClick={(e) => { e.preventDefault(); selectBotAvtarHandler() }}
                            >
                                <div className="symbol symbol-60px mb-2">
                                    <SAISVG path="media/icons/duotune/general/gen035.svg" className="svg-icon-muted svg-icon-3hx" />
                                </div>
                                <div className="fw-semibold fs-5">
                                    Agent Avatar
                                </div>
                                <div className="text-primary">
                                    (160 X 160 image are accepted)
                                </div> 
                            </a> 
                        : 
                            <>
                                <FontAwesomeIcon
                                    icon={faXmark} 
                                    style={{marginLeft:'100%', position:'absolute', top:'5', right:'5'}} 
                                    className='fs-3 text-gray-600 cursor-pointer' 
                                    onClick={botAvtarPreviewRemoveHandler}
                                />
                                <img
                                    src={botAvtarPreview}
                                    alt="Selected"
                                    className="w-100"
                                    style={{ height: "95px", objectFit: "contain" }}
                                /> 
                            </>
                        }
                        <input 
                            type='file' 
                            className='d-none'
                            ref={botavtarInputRef}
                            onChange={botAvtarChangeHandler}
                        />      
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className="form-label">
                        &nbsp;
                    </label>
                    <div className="card-body border border-dashed border-gray-300 d-flex text-center flex-column bg-light p-5 align-items-center position-relative">
                        {!brandIconPreview ?
                            <a 
                                href="#" 
                                className="text-gray-800 d-flex flex-column cursor-pointer"
                                onClick={(e) => { e.preventDefault(); selectBrandIconHandler() }}
                            >
                                <div className="symbol symbol-60px mb-2">
                                    <SAISVG path="media/icons/duotune/general/gen035.svg" className="svg-icon-muted svg-icon-3hx" />
                                </div>
                                <div className="fw-semibold fs-5">
                                    Brand Icon
                                </div>
                                <div className="text-primary">
                                    (200 X 200 image are accepted)
                                </div> 
                            </a>
                        :
                            <>
                                <FontAwesomeIcon
                                    icon={faXmark} 
                                    style={{marginLeft:'100%', position:'absolute', top:'5', right:'5'}} 
                                    className='fs-3 text-gray-600 cursor-pointer' 
                                    onClick={brandIconPreviewRemoveHandler}
                                />
                                <img
                                    src={brandIconPreview}
                                    alt="Selected"
                                    className="w-100"
                                    style={{ height: "95px", objectFit: "contain" }}
                                /> 
                            </>
                        }
                        <input
                            type='file'
                            ref={brandIconInputRef}
                            className='d-none'
                            onChange={brandIconChangeHandler}
                        />      
                    </div>
                </div>
                <div className='col-md-5 m-auto'>
                    <div className='d-flex'>
                       
                        <div className="form-check form-check-custom form-check-solid form-check-lg me-5">
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                value="default_widget" 
                                id="default_widget" 
                                name="widget_type"
                                onChange={widgetTypeChangeHandler}
                                checked={formData.step1.widget_type === 'default_widget'}
                            />
                            <label className="form-check-label fw-bold" htmlFor="default_widget">
                                Truchat Widget
                            </label>
                        </div>
                        <div className="form-check form-check-custom form-check-solid form-check-lg">
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                value="custom_hook" 
                                id="custom_hook"
                                name="widget_type"
                                onChange={widgetTypeChangeHandler}
                                checked={formData.step1.widget_type === 'custom_hook'}
                            />
                            <label className="form-check-label fw-bold" htmlFor="custom_hook">
                                Others Widget
                            </label>
                        </div>
                    </div>
                    {formValidateError.step1?.widget_type && 
                        <ValidationMessage className='text-danger ms-2' message ={formValidateError.step1.widget_type}/>
                    }
                </div>
                <div className='col-md-7'>
                    {
                        widgetType === 'custom_hook' && (
                            <input
                                type="text"
                                className={`form-control form-control-solid`}
                                placeholder="Enter hook url"
                                name="hook_url"
                                onChange={(e) => props.onInputChange('step1', 'hook_url', e.target.value)}
                                value={formData.step1.hook_url || ''}
                            /> 
                        )
                    }
                    {formValidateError.step1?.hook_url && 
                        <ValidationMessage className='text-danger ms-2' message ={formValidateError.step1.hook_url}/>
                    }
                    {
                        widgetType === 'default_widget' &&
                        <input
                            type="text"
                            className={`form-control form-control-solid`}
                            placeholder="Enter agent name"
                            disabled
                            name="widget_url"
                            onChange={(e) => props.onInputChange('step1', 'widget_url', e.target.value)}
                            value={formData.step1.widget_url || ''}
                        />
                    }
                    {formValidateError.step1?.widget_url && 
                        <ValidationMessage className='text-danger ms-2' message ={formValidateError.step1.widget_url}/>
                    }
                </div>
            </div>
        </>
    )
}

export default Step1